import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import React from 'react';

import ArrowDown from '../../icons/imaterial/arrows/Arrow Down.svg';
import useStyles from './Faq.style';

export interface FaqClasses {
  root?: string;
  question?: string;
  answer?: string;
}
export interface FaqProps {
  q: React.ReactNode;
  a: React.ReactNode;
  size?: 'small' | 'medium';
  classNames?: Partial<FaqClasses>
}

const Faq: React.FC<FaqProps> = (props) => {
  const { q, a, size, classNames } = props;
  const { classes, cx, theme } = useStyles({ size });

  return (
    <Accordion
      square
      classes={{ root: cx(classes.faqAccordion, classNames.root) }}
    >
      <AccordionSummary expandIcon={<ArrowDown className={classes.faqAccordionIcon} />}>
        <Typography
          component="div"
          className={cx(classes.faqQuestion, classNames.question)}
          fontFamily={theme.gh_vars.circular}
        >
          {q}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        <Typography
          component="div"
          className={cx(classes.faqAnswer, classNames.answer)}
        >
          {a}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};

Faq.defaultProps = {
  size: 'medium',
  classNames: {},
};

export default Faq;
